
import { getUser } from '@utils/auth';

const user = {
  data() {
    return {
      uId: null,
      phone: null
    };
  },
  created() {
    this.mixinSetUid();
  },
  methods: {
    mixinSetUid() {
      const userInfo = JSON.parse(getUser());
      if (!userInfo) { return }
      this.uId = userInfo.uid;
      this.phone = userInfo.phone;
    }
  }
};

export default user;
